import React from 'react';

/*
  ConsultationCard component
  Props:
    - type: consultation type object
    - selected: boolean
    - onSelect: function
*/
function ConsultationCard({ type, selected, onSelect }) {
  return (
    <div
      className={`consultation-card ${selected ? 'selected' : ''}`}
      onClick={onSelect}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') onSelect(); }}
    >
      <div className="consult-info">
        <h4 className="consult-name">{type.name}</h4>
        <div className="consult-details">
          <span className="consult-duration">⏱️ {type.duration_minutes} min</span>
          <span className="consult-price">{type.credits_required} credits</span>
        </div>
      </div>
      {selected && <div className="selected-indicator">✓</div>}
    </div>
  );
}

export default React.memo(ConsultationCard);